/**
 * @file required to properly setup paperjs
 */
import { paper } from '@aninix-inc/renderer'

// @NOTE: create ghost canvas to draw paper stuff on it
const canvas = document.createElement('canvas')
paper.setup(canvas)
paper.settings.insertItems = false
